import { useMutation } from '@tanstack/react-query';

import { generateReportFromAi } from '../api/ai-report.api';
import { AiChatHistoryMessage, GenerateReportFromAiResponse } from '../types/ai-report';

export const useGenerateReportFromAi = () => {
  return useMutation({
    mutationFn: ({
      reportId,
      messages,
    }: {
      reportId: string;
      messages: AiChatHistoryMessage[];
    }): Promise<GenerateReportFromAiResponse> => generateReportFromAi(reportId, messages),
  });
};
